import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { css } from 'styled-components';

// Other controls
import { Hint } from '@independent-software/typeui/controls/Form/Hint';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  /** Label to show above value */
  label: string;
  /** Unit to show. Can be JSX. */
  unit?: React.ReactNode;
  /** Optional flex width */
  width?: number;
  /** Optional hint text. Can be JSX. */
  hint?: React.ReactNode;
  /** If true, show no background and add no padding. */
  nobackground?: boolean;
}

const TextLabel = styled('div')`
  position: relative;
  font-weight: 500;
  font-size: 80%;
  margin-right: 1em;

  /* Ordinarily, labels are displayed above the field control: */
  display: block;
`

const Spacer = styled('div')`
  min-width: 150px;
  padding: 0 5px 0 5px;
`

const Block = styled('div')`
`

const Unit = styled('div')`
  position: absolute;
  right: 0;
  top: 0;
  background: #ddd;
  height: 38px;
  line-height: 38px;
  &:before {
    content: '';
    position: absolute;
    width: 0.6em;
    height: 0.6em;
    border-style: inherit;
    border-color: inherit;
    background: inherit;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);  
    top: 50%;
    border-width: 0 0 1px 1px;    
  }
  margin-left: 1em;
`

const UnitSpacer = styled('div')`
  padding: 0 10px 0 10px;
`

class OutputBase extends React.Component<IProps, {}> {
  render() {
    let p = this.props;
    // Does the label have content?
    let hasContent = React.Children.count(p.children) != 0;

    return (
      <div className={p.className}>
        <TextLabel>{p.label}</TextLabel>
        <Block>
          {!hasContent ? '-' : p.children}&nbsp;
          {p.unit && 
          <Unit>
            <UnitSpacer>
              {p.unit}
            </UnitSpacer>
          </Unit>}          
        </Block>
        {p.hint && <Hint>{p.hint}</Hint>}
      </div>
    );
  }
}

const OutputStyled = styled(OutputBase)`
  padding-bottom: 8px;

  /* Fields may provide their width in relative units to other fields. */
  ${(p:any) => p.width && css `flex: ${p.width}`}

  ${Block} {
    position: relative;
    background: #f6f6f6;
    padding: 7px 10px 7px 10px;
    ${p => p.nobackground && css`
      background: transparent;
      padding: 4px 0px 4px 0px;
    `}
    
  }
`

class Output extends React.Component<IProps> {
  render() {
    return (
      <OutputStyled {...this.props}></OutputStyled>
    )
  }
}

export { Output };
